import { CMC_MARKETING_TARGET } from '../../../constants/targets';
import { ESPOT_COMPONENT } from './constants';

export const getPageId = () => {
  return document
    .getElementById(CMC_MARKETING_TARGET)
    ?.getAttribute('data-pageid');
};

export const getPropMap = (propArray = []) =>
  propArray.reduce(
    (acc, cur) => ({
      ...acc,
      [cur.name]: cur.value
    }),
    {}
  );

export const enrichLayoutData = layout => ({
  ...layout,
  childWidget: layout.childWidget.map(child => {
    const {
      widgetProperty,
      slot: { internalSlotId },
      ...rest
    } = child;
    return {
      ...rest,
      widgetProps: getPropMap(widgetProperty),
      slot: internalSlotId
    };
  })
});
export const getPartNumbers = (partNumberData, productsArray) => {
  let data = partNumberData?.split(',');
  return productsArray?.map(product => {
    let partObj = {};
    data.forEach(item => {
      if (item === product.partNumber || item === product.itemPartNumber) {
        partObj = {
          partNumber: product.itemPartNumber ?? product.partNumber,
          quantity: 1,
          uniqueId: product.uniqueId
        };
      }
    });
    return partObj;
  });
};
export const getEspotNames = enrichedLayout =>
  enrichedLayout.childWidget
    .filter(child => child.widgetDefinitionIdentifier === ESPOT_COMPONENT)
    .map(ems => ems.widgetProps.emsName);
